<template>
  <div class="card-status">
    <Icon v-if="status" :icon="statusIcon" />
    <time v-if="date" class="card-status__date">{{ formatedDate(date) }}</time>
  </div>
</template>

<script>
// Utilities
import { getStatusIcon, formatDate } from 'Utils'
// Components
import Icon from 'Ui/AppIcon'

export default {
  name: 'CardSingleStatus',

  components: {
    Icon,
  },
  props: {
    status: {
      type: String,
      default: '',
    },
    date: {
      type: String,
      default: '',
    },
  },
  computed: {
    statusIcon() {
      return getStatusIcon(this.status)
    },
    formatedDate() {
      return (date) => formatDate(date)
    },
  },
}
</script>

<style scoped>
.card-status {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  flex: 0 0 38%;
  border-left: 1px solid var(--c-secondary-200);
}

.card-status i {
  font-size: 10px;
  color: var(--c-primary);
  margin-right: 6px;
}

.card-status__date {
  font-size: 9px;
  font-weight: 600;
  line-height: 11px;
  text-transform: uppercase;
  color: var(--c-secondary);
}
</style>
